export const ENVIRONMENT = process.env.REACT_APP_ENV || "dev";

export const SERVER_URL =
  process.env.REACT_APP_SERVER_URL || "https://backend.manutencaotelegen.com:4443";
